// packages/shared-hooks/src/lead-tasks/useUpdateLeadScore.ts
//
// `PATCH /leads/:id/score` (#2317 D-1) — the by-lead card score edit against
// the READ-ONLY Engagement projection. Backend returns 204 No Content and
// enforces admin-or-assigned authz (pool excluded). Success flushes the
// Engagement read keys so the header stars + list bucket re-read the saved
// score: invalidating the `detailByLead(leadId)` prefix covers both the
// default and the `fidelity` variant, and `lists()` covers every list filter.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateLeadScoreInput } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { engagementsKeys } from '../engagements/keys.js';

export function useUpdateLeadScore(leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<void, unknown, UpdateLeadScoreInput>({
    mutationFn: (input) => client.patch<void>(`/leads/${leadId}/score`, input, {}),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: engagementsKeys.detailByLead(leadId) });
      void qc.invalidateQueries({ queryKey: engagementsKeys.lists() });
    },
  });
}
